import btn from './button'
import common from './common'
import lbl from './label'
import mnu from './menu'
import msg from './message'
import tbl from './table'

export default {
  btn,
  common,
  lbl,
  mnu,
  msg,
  tbl
};
  